import { parseToStartOfMonth } from '@shared/utils/parse-to-start-of-month';

import { parseQuarterMonthDropdownLabel } from './parse-quarter-month-dropdown-label';
import { QuarterDate } from '../../../period-close.component';
import { ChecklistMonthlyDropdownDate } from '../models/quarter-close-checklist.model';

export function configureQuarterMonths(
  quarterMonths: QuarterDate[],
  currentOpenMonth: string
): ChecklistMonthlyDropdownDate[] {
  return quarterMonths.map((monthObj) => {
    const value = parseToStartOfMonth(monthObj.iso);
    const parsedQuarterMonth = parseQuarterMonthDropdownLabel(value, currentOpenMonth);

    const label = parsedQuarterMonth[0];
    const disabled = parsedQuarterMonth[1];

    return {
      ...monthObj,
      disabled,
      label,
      value,
    };
  });
}
